// Token rejection vs. transient failure: the backend reports a missing/expired/
// unauthorized public access token in the error message text. Substring-matched
// here (a deliberate loose coupling) so the public flow can branch on "this link
// isn't valid" without echoing raw error text. Pair any backend text change here.
export const isUnauthorizedTokenError = (error?: { message?: string } | null): boolean => {
  const message = (error && error.message) || '';
  return message.includes('access token') || message.includes('expired');
};
